/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
import {
  Typography,
  Modal,
  ModalHeader,
} from '@one-thd/sui-atomic-components';
import { useDataModel } from '@thd-nucleus/data-sources';
import React, { useState } from 'react';
import { bool, func, string, object } from 'prop-types';
import FormContent from './FormContent';
import LoadingContent from './LoadingContent';
import SuccessContent from './SuccessContent';

export const RegistrationModal = ({
  modalOpen, modalOnClose, workshopsData, storeId, svocId
}) => {

  const [modalPage, setModalPage] = useState('form');
  const [registrationData, setRegistrationData] = useState({});

  const { data, loading, error } = useDataModel('storeSearch', {
    variables: {
      storeSearchInput: storeId,
      pagesize: 1
    }
  });

  const handleClose = () => {
    modalOnClose();
    setModalPage('form');
  };

  return (
    <Modal
      open={modalOpen}
      size="sm"
      onClose={handleClose}
    >
      <div>
        <ModalHeader onClose={handleClose}>
          <Typography variant="h3" weight="condensed">
            {
              modalPage === 'success' ? 'You\'re Signed Up!'
                : 'Register for a Workshop'
            }
          </Typography>
        </ModalHeader>

        {
          modalPage === 'loading'
            ? <LoadingContent />
            : modalPage === 'success' && registrationData
              ? (
                <SuccessContent
                  registrationData={registrationData}
                  setModalPage={setModalPage}
                  modalOnClose={modalOnClose}
                />
              )

              : modalPage === 'form' && modalOpen
                ? (
                  <FormContent
                    svocId={svocId}
                    setModalPage={setModalPage}
                    workshopsData={workshopsData}
                    storeData={data}
                    setRegistrationData={setRegistrationData}
                  />
                )
                : ''
        }
      </div>
    </Modal>
  );
};

RegistrationModal.displayName = 'RegistrationModal';
RegistrationModal.propTypes = {
  modalOpen: bool.isRequired,
  modalOnClose: func.isRequired,
  workshopsData: object.isRequired,
  storeId: string.isRequired,
  svocId: string
};
